import { call, put, takeLatest } from 'redux-saga/effects';
import { cancelRefundFailure, cancelRefundRequest, cancelRefundSuccess } from './refundsSlice';
import { apiClient } from '../../utils/axios';

function* cancelRefundSaga(action) {
  try {
    const { url, reason } = action.payload;
    const data = { reason };
    const response = yield call(apiClient.put, url, data);
    yield put(cancelRefundSuccess(response.data));
  } catch (error) {
    yield put(cancelRefundFailure(error.response?.data?.errors));
  }
}

function* refundsSaga() {
  yield takeLatest(cancelRefundRequest.type, cancelRefundSaga);
}

export default refundsSaga;
